// extracted by mini-css-extract-plugin
export default {"title":"Input_title__ueyJj","input":"Input_input__UmSRV","ready":"Input_ready__LdcFe","right":"Input_right__HATYR","wrong":"Input_wrong__whBXB","errMsg":"Input_errMsg__CdoU5"};